import Vue from "vue";

export default {
  GetJson(url) {
    return Vue.http.get(url).then(
      result =>     { return result.json(); },
      error =>      { console.error(error); }
    );
  },
  PostJSON(url, data) {
    return Vue.http
      .post(url, data, {
        emulateHTTP: true,
        emulateJSON: true
      })
      .then(
        result =>   { return result.json(); },
        error =>    { console.error(error); }
      );
  }
};
